import { isEmailAddress } from './isEmailAddress';
import { isPostalCode } from './isPostalCode';
/**
 * tests PII on a string
 */
export function containsPIIData(input) {
    const inputString = input.toString();
    const containsPostalCode = isPostalCode(inputString);
    const containsEmail = isEmailAddress(inputString);
    return !!(containsPostalCode || containsEmail);
}
